import { connect } from 'react-redux';
import RefundPolicy from './RefundPolicy';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const RefundPolicyContainer = connect(mapStateToProps, mapDispatchToProps)(RefundPolicy);

export default RefundPolicyContainer;